import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
  background?: boolean
  opacity?: number
  color?: string
}

export const CloseIcon: FC<Props> = ({
  size = 18,
  background = false,
  opacity = 1,
  color = 'white',
  ...props
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    {background && (
      <rect
        width="24"
        height="24"
        rx="12"
        fill="black"
        fillOpacity="0.5"
        stroke="none"
      />
    )}
    <path
      d="M17 7L7 17"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={opacity}
    />
    <path
      d="M7 7L17 17"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={opacity}
    />
  </svg>
)
